import launchWriteReview from 'util/launch-write-review'

export function writeReview() {
  launchWriteReview()
}
